import { render } from "./WebsiteDetail.vue?vue&type=template&id=23a8f232&scoped=true"
import script from "./WebsiteDetail.vue?vue&type=script&lang=js"
export * from "./WebsiteDetail.vue?vue&type=script&lang=js"

import "./WebsiteDetail.vue?vue&type=style&index=0&id=23a8f232&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a8f232"]])

export default __exports__